import { sha256 } from 'js-sha256';

/**
 * Derives a hash of the given Kyber public key.
 * 
 * This hash can be used as a lightweight identifier or lookup key
 * (e.g., to match against a hash sent inside a handshake confirm payload).
 *
 * @param kyberPublicKey - Kyber public key to hash
 * @returns 32-byte SHA-256 hash as a Uint8Array
 */
export function deriveKyberPublicKeyHash({
  kyberPublicKey,
}: {
  kyberPublicKey: Uint8Array;
}): Uint8Array {
  const hash = sha256.array(kyberPublicKey); // returns Uint8Array(32)
  return new Uint8Array(hash);
}